import gql from "graphql-tag"

export default gql`
  fragment SourceAssetFragment on SourceAsset {
    id
    sourceId
    externalId
    fileId
    name
    remotePath
    size
    status
    candidate
    matchedMovieId
    matchedEpisodeId
    matchConfidence
    importId
    error
    attempts
    firstSeenAt
    lastSeenAt
  }
`
